import {Enum} from 'enumify'

class TimezoneEnumParser extends Enum {}
TimezoneEnumParser.initEnum({
  HST: {
    apiName: 'HST',
    timezone: 'HAWAII'
  },
  AKST: {
    apiName: 'AKST',
    timezone: 'ALASKA'
  },
  PST: {
    apiName: 'PST',
    timezone: 'PACIFIC'
  },
  MST: {
    apiName: 'MST',
    timezone: 'MOUNTAIN'
  },
  CST: {
    apiName: 'CST',
    timezone: 'CENTRAL'
  },
  EST: {
    apiName: 'EST',
    timezone: 'EASTERN'
  },
  AST: {
    apiName: 'AST',
    timezone: 'ATLANTIC'
  },
  AZ: {
    apiName: 'AZ',
    timezone: 'ARIZONA'
  }
})
export function getTimeZoneEnumParser (apiName) {
  for (const type of TimezoneEnumParser.enumValues) {
    if (type.apiName === apiName) {
      return type.timezone
    }
  }
}
export default TimezoneEnumParser



// WEBPACK FOOTER //
// ./src/components/shared/enums/timezone-enum-parser.jsx